document.addEventListener('DOMContentLoaded', () => {
    // 1. Zoek ALLE secties op de pagina, zodat we meerdere secties kunnen gebruiken
    const sections = document.querySelectorAll('.advanced-editorial-section');
    if (sections.length === 0) return; 

    // 2. Wacht op GSAP plugins
    const initGSAP = setInterval(() => {
        if (window.gsap && window.Flip && window.ScrollToPlugin) {
            clearInterval(initGSAP); 
            
            gsap.registerPlugin(Flip, ScrollToPlugin);
            
            // 3. Loop door elke sectie heen om de logica te isoleren (Scoped Logic)
            sections.forEach(section => {
                const grid = section.querySelector('.editorial-grid');
                if (!grid) return;

                const cards = gsap.utils.toArray(section.querySelectorAll('.card'));
                let activeCard = null;

                cards.forEach(card => {
                    card.addEventListener('click', (e) => {
                        if (e.target.closest('.btn-close')) return;
                        if (card.classList.contains('is-expanded')) return;
                        expandCard(card, grid, cards);
                    });

                    const closeBtn = card.querySelector('.btn-close');
                    if(closeBtn) {
                        closeBtn.addEventListener('click', (e) => {
                            e.stopPropagation(); 
                            closeCard(card, grid, cards);
                        });
                    }
                });

                function expandCard(card, grid, cards) {
                    // Record state inclusief de specifieke grid van deze sectie
                    const state = Flip.getState([grid, ...cards]);
                    grid.classList.add('is-animating');

                    if (activeCard && activeCard !== card) {
                        activeCard.classList.remove('is-expanded');
                        gsap.set(activeCard.querySelector('.card-content-expanded'), { opacity: 0 });
                    }

                    card.classList.add('is-expanded');
                    activeCard = card;

                    // Scroll berekening gecorrigeerd voor Shopify header offsets indien nodig
                    const rect = card.getBoundingClientRect();
                    const cardTopInDocument = window.scrollY + rect.top;
                    const targetY = cardTopInDocument - (window.innerHeight / 2) + (rect.height / 2);

                    Flip.from(state, {
                        duration: 0.7,
                        ease: "power3.inOut",
                        absolute: cards, // Alleen de kaarten absoluut maken, niet de grid
                        zIndex: 20,
                        onComplete: () => {
                            grid.classList.remove('is-animating');
                            gsap.to(card.querySelector('.card-content-expanded'), {
                                opacity: 1,
                                duration: 0.4,
                                ease: "power2.out"
                            });
                        }
                    });

                    gsap.to(window, {
                        scrollTo: { y: targetY },
                        duration: 0.7,
                        ease: "power3.inOut"
                    });
                }

                function closeCard(card, grid, cards) {
                    gsap.to(card.querySelector('.card-content-expanded'), {
                        opacity: 0,
                        duration: 0.2,
                        onComplete: () => {
                            const state = Flip.getState([grid, ...cards]);
                            grid.classList.add('is-animating');
                            
                            card.classList.remove('is-expanded');
                            activeCard = null;

                            Flip.from(state, {
                                duration: 0.7,
                                ease: "power3.inOut",
                                absolute: cards,
                                onComplete: () => {
                                    grid.classList.remove('is-animating');
                                }
                            });
                        }
                    });
                }

                // Klik buiten sectie = sluiten
                document.addEventListener('click', (e) => {
                     if (activeCard && !e.target.closest('.card')) {
                         closeCard(activeCard, grid, cards);
                     }
                });
            });
        }
    }, 100); 
});